"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var CurrencyCodes = _interopRequireWildcard(require("self-service-api/constants/CurrencyCodes"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _ActiveCurrencyCodeActions = require("pricing-pages-unified-ui/actions/ActiveCurrencyCodeActions");

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _responsiveBreakpoints2 = require("pricing-pages-unified-ui/utils/responsiveBreakpoints");

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var _CurrencyCodeToSymbol;

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      z-index: 6;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    border-left: 0 !important;\n    \n    &:first-child {\n      border-top-left-radius: 0;\n    }\n  \n    &:last-child {\n      border-bottom-left-radius: 0;\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  z-index: 5;\n  :hover {\n    z-index: 6;\n  }\n  .currency-selector__text {\n    font-size: 12px;\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    position: static;\n    margin: 1.4em 0;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  margin-top: 100px;\n  &.mon307MoveDown {\n    margin-top: 190px;\n  }\n  z-index: 2;\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      display: none;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 15px;\n    .currency-symbol {\n      display: none;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    position: static;\n    top: initial;\n    text-align: center;\n    background-color: #f5f8fa;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: sticky;\n  top: 25%;\n  z-index: 2;\n  ", ";\n  ", ";\n\n  .currency-symbol {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CurrencyCodeToSymbol = (_CurrencyCodeToSymbol = {}, (0, _defineProperty2.default)(_CurrencyCodeToSymbol, CurrencyCodes.USD, '$'), (0, _defineProperty2.default)(_CurrencyCodeToSymbol, CurrencyCodes.EUR, '€'), (0, _defineProperty2.default)(_CurrencyCodeToSymbol, CurrencyCodes.GBP, '£'), (0, _defineProperty2.default)(_CurrencyCodeToSymbol, CurrencyCodes.AUD, '$'), (0, _defineProperty2.default)(_CurrencyCodeToSymbol, CurrencyCodes.JPY, '¥'), (0, _defineProperty2.default)(_CurrencyCodeToSymbol, CurrencyCodes.SGD, '$'), (0, _defineProperty2.default)(_CurrencyCodeToSymbol, CurrencyCodes.COP, '$'), _CurrencyCodeToSymbol);

var CurrencySelectorWrapper = _styledComponents.default.div.withConfig({
  displayName: "CurrencyPicker__CurrencySelectorWrapper",
  componentId: "sc-1otai6g-0"
})(_templateObject(), _responsiveBreakpoints.default.tablet(_templateObject2()), _responsiveBreakpoints.default.phone(_templateObject3()), _responsiveBreakpoints.default.phone(_templateObject4()));

var StyledButtonGroup = (0, _styledComponents.default)(_UIButtonGroup.default).withConfig({
  displayName: "CurrencyPicker__StyledButtonGroup",
  componentId: "sc-1otai6g-1"
})(_templateObject5(), _responsiveBreakpoints.default.tablet(_templateObject6()));
var StyledSelectableBox = (0, _styledComponents.default)(_UISelectableBox.default).withConfig({
  displayName: "CurrencyPicker__StyledSelectableBox",
  componentId: "sc-1otai6g-2"
})(_templateObject7(), _responsiveBreakpoints2.minWidthBreakpoint.tablet(_templateObject8()), function (_ref) {
  var selected = _ref.selected;
  return selected && (0, _styledComponents.css)(_templateObject9());
});

var windowWidthIsMobile = function windowWidthIsMobile() {
  return window.innerWidth <= _responsiveBreakpoints2.breakpointValues.tablet;
};

var CurrencyPicker = function CurrencyPicker(_ref2) {
  var availableCurrencies = _ref2.availableCurrencies,
      activeCurrencyCode = _ref2.activeCurrencyCode,
      onUpdateActiveCurrencyCode = _ref2.onUpdateActiveCurrencyCode,
      _ref2$mon307MoveDown = _ref2.mon307MoveDown,
      mon307MoveDown = _ref2$mon307MoveDown === void 0 ? false : _ref2$mon307MoveDown;

  var handleClick = function handleClick(currency) {
    onUpdateActiveCurrencyCode(currency);
    (0, _getUsageTracker.default)().track('selectCurrency', {
      currency: currency
    });
  };

  var _useState = (0, _react.useState)(windowWidthIsMobile()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  (0, _react.useEffect)(function () {
    var mobileCheck = function mobileCheck() {
      if (windowWidthIsMobile() !== isMobile) setIsMobile(windowWidthIsMobile());
    };

    window.addEventListener('resize', mobileCheck);
    return function () {
      return window.removeEventListener('resize', mobileCheck);
    };
  }, [isMobile]);
  return availableCurrencies.length <= 1 ? null : _react.default.createElement(CurrencySelectorWrapper, null, _react.default.createElement(StyledButtonGroup, {
    orientation: isMobile ? 'horizontal' : 'vertical',
    className: (0, _classNames.default)('currency-selector__button-group', mon307MoveDown && 'mon307MoveDown')
  }, availableCurrencies.map(function (currency) {
    var selected = activeCurrencyCode === currency;
    var gaClassName = (0, _publicPageUrls.getGAClassName)("currency-pricing-" + currency.toLowerCase());
    return _react.default.createElement(StyledSelectableBox, {
      key: currency,
      selected: selected,
      onClick: function onClick() {
        return handleClick(currency);
      },
      className: "p-all-2 " + gaClassName
    }, _react.default.createElement("span", {
      className: "currency-selector__text " + gaClassName
    }, currency, _react.default.createElement("span", {
      className: "currency-symbol"
    }, ' ', CurrencyCodeToSymbol[currency])));
  })));
};

CurrencyPicker.propTypes = {
  availableCurrencies: _propTypes.default.array.isRequired,
  activeCurrencyCode: _propTypes.default.oneOf(Object.values(CurrencyCodes || {})),
  onUpdateActiveCurrencyCode: _propTypes.default.func.isRequired,
  mon307MoveDown: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    availableCurrencies: (0, _CurrencySelectors.availableCurrenciesSelectorWithNoMerchId)(state),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUpdateActiveCurrencyCode: function onUpdateActiveCurrencyCode(currency) {
      return dispatch((0, _ActiveCurrencyCodeActions.updateActiveCurrencyCode)({
        currency: currency
      }));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CurrencyPicker);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CurrencyPicker.js
// module id = 174
// module chunks = 5 6